<style scoped>
.w-e-text-container {
  height: 400px !important;
}
</style>
<template>
  <div>
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li class="breadcrumb-item active">
        <a href="javascript:;">通告管理</a>
      </li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      通告管理
      <small>配置通告管理...</small>
    </h1>
    <!-- end page-header -->
    <panel title="通告管理" :noButton="true">
      <div slot="heading-btn">
        <button type="button" class="btn btn-theme btn-sm" @click="fn_add_notice">
          <i class="fa fa-plus"></i>
          添加通告
        </button>
      </div>
      <Table border size="small" :columns="columns" :data="data">
        <template slot-scope="{ row }" slot="status">
          <strong v-if="row.status == 0">有效</strong>
          <strong v-else style="color:red">无效</strong>
        </template>
        <template slot="logo" slot-scope="{row}">
          <img :src="logourl+row.logo" style="max-height:100px" />
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <button
            type="button"
            class="btn btn-theme btn-sm"
            style="margin-right: 5px"
            @click="fn_edit_notices(row, index)"
          >通告管理</button>

          <Poptip
            transfer
            confirm
            title="是否要删除此通告?"
            @on-ok="fn_remove(row, index)"
            ok-text="确认"
            cancel-text="取消"
          >
            <button type="button" class="btn btn-danger btn-sm">作废</button>
          </Poptip>
        </template>
      </Table>
      <Page
        style="margin-top:10px"
        :total="totalRows"
        :current="currentPage"
        :page-size="pageNum"
        show-total
        show-elevator
        @on-change="fn_switchPage"
      />
    </panel>
    <Drawer title="通告信息" v-model="v_edit_notice" width="80" :mask-closable="true" :styles="styles">
      <Form :model="formData" ref="formData" :labelWidth="120" :rules="rules">
        <Row :gutter="32">
          <Col span="8">
            <FormItem label="标题" prop="title">
              <Input v-model="formData.title" placeholder="请输入标题" :maxlength="255" />
            </FormItem>
            <FormItem label="Logo图片" prop="logo">
              <Upload
                name="filename"
                :show-upload-list="false"
                :action="uploadhost"
                :format="['jpg','jpeg','png']"
                :on-success="fn_uploadSuccess"
                :max-size="2048"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                style="display: inline-block;width:90px;"
              >
                <Button icon="ios-cloud-upload-outline">上传图片</Button>
              </Upload>
            </FormItem>
            <FormItem label="图片" v-if="formData.logo.length>0">
              <img :src="logourl+formData.logo" style="max-height:100px" />
            </FormItem>
            <FormItem label="开始时间" prop="begintime">
              <DatePicker
                v-model="formData.begintime"
                type="datetime"
                placeholder="please select the date"
                style="display: block"
                placement="bottom-end"
              ></DatePicker>
            </FormItem>
            <FormItem label="结束时间" prop="endtime">
              <DatePicker
                v-model="formData.endtime"
                type="datetime"
                placeholder="please select the date"
                style="display: block"
                placement="bottom-end"
              ></DatePicker>
            </FormItem>
            <FormItem label="状态">
              <Select v-model="formData.status">
                <Option :value="-1">无效</Option>
                <Option :value="0">有效</Option>
              </Select>
            </FormItem>
            <FormItem label="简要描述" prop="breif">
              <Input type="textarea" v-model="formData.breif" :rows="10" placeholder="通告的简要描述" />
            </FormItem>
          </Col>
          <Col span="16">
            <FormItem label="详细内容">
              <div class="editor-wrapper">
                <div :id="editorId"></div>
              </div>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px" @click="v_edit_notice = false">取消</Button>
        <Button type="primary" @click="fn_store_notice">保存</Button>
      </div>
    </Drawer>
  </div>
</template>
<script>
import { getToken } from "@/libs/util";
import config from "@/config";
import Editor from "wangeditor";
import "wangeditor/release/wangEditor.css";
import moment from "moment";
import {
  getNoticesList,
  removeNoticeData,
  storeNoticesData
} from "@/api/notices";
export default {
  computed: {
    editorId() {
      return `editor${this._uid}`;
    }
  },
  data() {
    return {
      uploadhost: config.baseUrl.pro + "/upload/uploadfile",
      logourl: config.baseUrl.imageurl,
      columns: [
        {
          title: "标题",
          key: "title",
          width: 200
        },
        {
          title: "示意图",
          slot: "logo",
          width: 200
        },
        {
          title: "主要描述",
          key: "breif"
        },
        {
          title: "状态",
          slot: "status",
          width: 120
        },
        {
          title: "操作",
          slot: "action",
          width: 200,
          align: "left"
        }
      ],
      data: [],

      totalRows: 0,
      pageNum: 10,
      currentPage: 1,

      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      formData: {
        id: 0,
        title: "",
        logo: "",
        breif: "",
        content: "",
        begintime: moment().format("YYYY-MM-DD HH:mm:ss"),
        endtime: moment()
          .add(180, "days")
          .format("YYYY-MM-DD HH:mm:ss"),
        status: 0
      },
      rules: {
        title: [
          {
            required: true,
            message: "标题必填",
            trigger: "blur"
          }
        ],
        breif: [
          {
            required: true,
            message: "简要描述必填",
            trigger: "blur"
          }
        ]
      },
      v_edit_notice: false
    };
  },
  mounted() {
    let filterCond = {
      page: 1,
      pageNum: this.pageNum
    };
    this.fn_load_data(filterCond);
    this.iniRichText();
  },
  methods: {
    fn_load_data(filterCond) {
      getNoticesList(filterCond).then(res => {
        this.data = res.data.data;
        this.totalRows = res.data.total;
      });
    },
    fn_switchPage(page) {
      this.currentPage = page;
      let filterCond = {
        page: page,
        pageNum: this.pageNum
      };
      this.fn_load_data(filterCond);
    },
    fn_add_notice() {
      this.v_edit_notice = true;
      this.formData = {
        id: 0,
        title: "",
        logo: "",
        breif: "",
        content: "",
        begintime: moment().format("YYYY-MM-DD HH:mm:ss"),
        endtime: moment()
          .add(180, "days")
          .format("YYYY-MM-DD HH:mm:ss"),
        status: 0
      };
    },
    fn_edit_notices(row, index) {
      this.formData = row;
      this.editor.txt.html(row.content);
      this.v_edit_notice = true;
    },
    fn_store_notice() {
      this.formData.begintime = moment(this.formData.begintime).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.formData.endtime = moment(this.formData.endtime).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.$refs.formData.validate(valid => {
        if (valid) {
          storeNoticesData(this.formData)
            .then(res => {
              if (res.data.code == 200) {
                if (this.formData.id == 0) {
                  this.data.push(res.data.data);
                }
                this.v_edit_notice = false;
                this.$Notice.success(res.data);
              } else {
                this.$Notice.error(res.data);
              }
            })
            .catch(error => {
              this.$Message.error(error);
            });
        }
      });
    },
    fn_remove(row, index) {
      removeNoticeData(row.id)
        .then(res => {
          if (res.data.code == 200) {
            this.data.splice(index, 1);
            this.$Notice.success(res.data);
          } else {
            this.$Notice.error(res.data);
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_uploadSuccess(res, file) {
      if (file.response.code === 200) {
        this.formData.logo = file.response.data;
      }
    },

    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式不正确",
        desc:
          "文件 " + file.name + " 格式不正确，请上传 jpg 或 png 格式的图片。"
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "超出文件大小限制",
        desc: "文件 " + file.name + " 太大，不能超过 2M。"
      });
    },
    iniRichText() {
      // console.log(this.Field.columname, this.FieldListData);
      this.editor = new Editor(`#${this.editorId}`);
      this.editor.customConfig.onchange = html => {
        let text = this.editor.txt.text();
        if (this.cache) localStorage.editorCache = html;
        this.$emit("input", this.valueType === "html" ? html : text);
        this.$emit("on-change", html, text);
      };
      this.editor.customConfig.onchangeTimeout = this.changeInterval;
      // create这个方法一定要在所有配置项之后调用
      this.editor.customConfig.zIndex = 1; // 设置菜单的垂直高度

      this.editor.customConfig.uploadImgServer = this.uploadhost;
      //  "http://47.106.198.122/api/CanteenAdmin/CanteenManagement/UploadImage"; // 配置服务器端地址
      this.editor.customConfig.uploadImgHeaders = {
        Authorization: "Bearer" + getToken()
      }; // 自定义 header
      this.editor.customConfig.uploadFileName = "filename"; // 后端接受上传文件的参数名
      this.editor.customConfig.uploadImgMaxSize = 2 * 1024 * 1024; // 将图片大小限制为 2M
      this.editor.customConfig.uploadImgMaxLength = 6; // 限制一次最多上传 3 张图片
      this.editor.customConfig.uploadImgTimeout = 3 * 60 * 1000; // 设置超时时间
      // this.editor.customConfig.uploadParams = {formFile:'2'};
      // 配置菜单
      this.editor.customConfig.menus = [
        "head",
        "bold", // 粗体
        "fontSize", // 字号
        "fontName", // 字体
        "italic", // 斜体
        "underline", // 下划线
        "strikeThrough", // 删除线
        "foreColor", // 文字颜色
        "backColor", // 背景颜色
        "link", // 插入链接
        "list", // 列表
        "justify", // 对齐方式
        "quote", // 引用
        "emoticon", // 表情
        "image", // 插入图片
        "table", // 表格
        "video", // 插入视频
        "code", // 插入代码
        "undo", // 撤销
        "redo" // 重复
      ];

      this.editor.customConfig.uploadImgHooks = {
        fail: (xhr, editor, result) => {
          // 插入图片失败回调
        },
        success: (xhr, editor, result) => {
          // 图片上传成功回调
          //
          let imgUrl = result.data;
          insertImg(imgUrl);
        },
        timeout: (xhr, editor) => {
          // 网络超时的回调
        },
        error: (xhr, editor) => {
          console.log(editor);
          // 图片上传错误的回调
        },
        customInsert: (insertImg, result, editor) => {
          // 图片上传成功,插入图片的回调

          // if(result.code == 200){
          var url = this.logourl + result.data;
          //   console.log(url);
          insertImg(url); //将内容插入到富文本中
          // console.log(insertImg(url)+"DFDF")
          // console.log(data+"dsfd")
          // }
        }
      };

      this.editor.customConfig.onchange = html => {
        this.info_ = html; // 绑定当前逐渐地值
        this.$emit("change", this.info_); // 将内容同步到父组件中
        this.formData.content = html;
      };

      // 创建富文本编辑器

      this.editor.create();
      // 如果本地有存储加载本地存储内容
    }
  }
};
</script>
